import { Dispatch } from "redux";
import PaymentMethod from "onnit-ui/lib/@types/interfaces/payment-method/PaymentMethod";
import PaymentMethodTypeEnum from "onnit-ui/lib/@types/enums/payment-method/PaymentMethodTypeEnum";
import Action from "../../interfaces/Action";
import ActionTypeEnum from "../../enums/ActionTypeEnum";
import ThunkAction from "../../interfaces/ThunkAction";
import CartPaymentGatewayClient from "../../clients/cart/CartPaymentGatewayClient";
import PaymentGateways from "../../interfaces/payment/PaymentGateways";
import TokenizedPaymentMethod from "../../interfaces/payment/TokenizedPaymentMethod";
import PaymentMethodClient from "../../clients/PaymentMethodClient";

// ------------------------- [ Action Creators ] -------------------------

const setPaymentGateways = (gateways: PaymentGateways): Action => ({
    type: ActionTypeEnum.PAYMENT_GATEWAY_SET,
    gateways,
});

export const setPaymentTokenizedMethods = (methods: TokenizedPaymentMethod[]): Action => ({
    type: ActionTypeEnum.PAYMENT_TOKENIZED_SET,
    methods,
});

export const addPaymentTokenizedMethod = (method: TokenizedPaymentMethod): Action => ({
    type: ActionTypeEnum.PAYMENT_TOKENIZED_ADD,
    method,
});

export const removePaymentTokenizedMethod = (method: TokenizedPaymentMethod): Action => ({
    type: ActionTypeEnum.PAYMENT_TOKENIZED_REMOVE,
    method,
});

export const setPaymentTokenizedMethodSelected = (selected: TokenizedPaymentMethod | null): Action => ({
    type: ActionTypeEnum.PAYMENT_TOKENIZED_SET_SELECTED,
    selected,
});

export const setDeviceData = (deviceData: string): Action => ({
    type: ActionTypeEnum.PAYMENT_DEVICE_DATA_SET,
    deviceData,
});

export const setDoSave = (doSave: boolean | null): Action => ({
    type: ActionTypeEnum.PAYMENT_DO_SAVE_SET,
    doSave,
});

export const setPaymentError = (error: string): Action => ({
    type: ActionTypeEnum.PAYMENT_ERROR_SET,
    error,
});

// ------------------------- [ Thunks ] -------------------------

const cartPaymentGatewayClient = new CartPaymentGatewayClient();

export const loadPaymentGateways = (cartUuid: string): ThunkAction<Promise<PaymentGateways>> => (
    async (dispatch: Dispatch) => {
        const response = await cartPaymentGatewayClient.getPaymentGateways(cartUuid);
        dispatch(setPaymentGateways(response.data));

        return response.data;
    }
);

const paymentMethodClient = new PaymentMethodClient();

export const loadCustomerPaymentMethods = (customerId: number): ThunkAction<Promise<PaymentMethod[]>> => (
    async () => {
        const response = await paymentMethodClient.listMethods(customerId);
        // Exclude Apple Pay and duplicates.  Stored Apple Pay payments cannot be used per Braintree tech support team.
        return response.data.filter((method) => !method.is_duplicate && method.method_type !== PaymentMethodTypeEnum.APPLE_PAY);
    }
);
